import { useEffect, useRef } from "react";

/** A link may ask a page to show one card (the first setup round, 2026-10-22: Home's checklist opens a project's General page "at the Mail
 *  card", `?card=mail`, or its sender step, `?card=sending`). The app moves between screens without a page load, so an anchor scrolls
 *  nothing, and the card's content arrives after its own read and grows (the red team's item 21): once the card is drawn, the element is
 *  scrolled to, and again a moment later while the content below it settles. Once per mount. */
export function useScrollToCard(target: () => HTMLElement | null, wanted: boolean, ready: boolean): void {
  const done = useRef(false);
  useEffect(() => {
    if (!wanted || !ready || done.current) return;
    done.current = true;
    const go = () => target()?.scrollIntoView({ block: "start" });
    const frame = requestAnimationFrame(go);
    const later = [150, 500].map((ms) => window.setTimeout(go, ms));
    return () => { cancelAnimationFrame(frame); later.forEach((t) => window.clearTimeout(t)); };
  }, [wanted, ready, target]);
}
